import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { CustomerOnboardFlowService } from '../../customer-onboard-flow.service';
import * as OnboardingActions from './onboarding.actions';
import { GlobalService } from 'app/global/global.service';
import { Router } from '@angular/router';
import * as AuthActions from '../../../../../store/actions/auth.action';

import { ICheckTokenResponse } from './onboarding.responses.dto';
import { Store } from '@ngrx/store';

@Injectable()
export class OnboardingEffects {
  constructor(
    private actions$: Actions,
    private customerOnboardFlowService: CustomerOnboardFlowService,
    private _router: Router,
    private _globalService$: GlobalService,
    private store: Store
  ) { }

  onboardingSubmit$ = createEffect(() =>
    this.actions$.pipe(
      ofType(OnboardingActions.onboardingSubmit),
      switchMap(({ formData, token }) =>
        this.customerOnboardFlowService.saveOnboardingData(formData, token).pipe( // Use the service for API call
          map((response) => OnboardingActions.onboardingSubmitSucceeded({ response })),
          catchError((error) => of(OnboardingActions.onboardingSubmitFailed({ error })))
        )
      )
    )
  );

  onboardingInviteSubmit$ = createEffect(() =>
    this.actions$.pipe(
      ofType(OnboardingActions.onboardingInvitedSubmit),
      switchMap(({ formData, apiUrl }) =>
        this.customerOnboardFlowService.saveInvitedOnboardingData(formData, apiUrl).pipe( // Use the service for API call
          map((response) => OnboardingActions.onboardingSubmitSucceeded({ response })),
          catchError((error) => of(OnboardingActions.onboardingSubmitFailed({ error })))
        )
      )
    )
  );

  onboardingSubmitSucceeded$ = createEffect(() =>
    this.actions$.pipe(
      ofType(OnboardingActions.onboardingSubmitSucceeded),
      tap(({ response }) => {
        if (response.invite_team_token) {
          this._router.navigate(['onboarding/team-invitation', response.invite_team_token]);
        } else {
          this.store.dispatch(AuthActions.loginSuccess({
            userData: response,
            formData: null,
            isThirdPartyLogin: false
          }));
        }
      })
    ),
    { dispatch: false }
  );

  checkToken$ = createEffect(() =>
    this.actions$.pipe(
      ofType(OnboardingActions.checkToken),
      switchMap(({ token }) =>
        this.customerOnboardFlowService.checkToken(token).pipe(
          map((response) => OnboardingActions.checkTokenSuccess({ response })),
          catchError((error) => of(OnboardingActions.checkTokenFailure({ error })))
        )
      )
    )
  );

  showErrorOnFailure$ = createEffect(() =>
    this.actions$.pipe(
      ofType(
        OnboardingActions.onboardingSubmitFailed,
        OnboardingActions.checkTokenFailure,
        OnboardingActions.updateError),
      tap(({ error }) => {
        if (error !== null) {
          this._globalService$.toastrError(error);
        }
      })
    ),
    { dispatch: false }
  )
}
